// extracted by mini-css-extract-plugin
module.exports = {"Typeahead":"FromEmail_Typeahead__rCCb+","List":"FromEmail_List__fvUuS","open":"FromEmail_open__YcFW5"};